import { PropsWithChildren, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { isClient } from '@revenuemarket/utils';

import { setStyle } from './helper';

interface Props {
  zIndex?: number;
  className: string;
  customStyle?: Partial<CSSStyleDeclaration>;
}

export function PortalContainer({ children, className, customStyle }: PropsWithChildren<Props>) {
  const [mounted, setMounted] = useState<boolean>();
  const [portalElement, setPortalElement] = useState<Element>();
  const rootElement = isClient() ? document.querySelector('body') : null;

  useEffect(() => {
    if (isClient()) {
      const el = setStyle(document.createElement('div'), customStyle);
      el.className = className;
      setPortalElement(el);

      return () => {
        if (rootElement && el && rootElement.contains(el) && el.children.length === 0) {
          rootElement.removeChild(el);
        }
      };
    }
  }, []);

  useEffect(() => {
    if (portalElement && rootElement) {
      rootElement.appendChild(portalElement);
    }

    setMounted(true);
  }, [portalElement]);

  return mounted && portalElement ? <>{createPortal(children, portalElement)}</> : null;
}
